module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "ushk-rili_list-wrap J_rili_listItem"
  }, [(!_vm.datas || !_vm.datas.length) ? _c('li', {
    staticClass: "ushk-rili_list-empty"
  }, [_c('img', {
    attrs: {
      "src": "//cdn.jin10.com/assets/img/sites/rili/empty_rili.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(!_vm.datas ? '加载中......' : _vm.noneText))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.datas), function(data, index) {
    return _c('li', {
      staticClass: "ushk-rili_list-item",
      class: {
        important: data.star > 2
      }
    }, [_c('div', {
      staticClass: "ushk-rili_list-country"
    }, [_c('img', {
      attrs: {
        "src": ("//cdn.jin10.com/assets/img/commons/flag/flash/" + (data.country) + ".png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ushk-rili_list-body"
    }, [_c('div', {
      staticClass: "ushk-rili_list-h"
    }, [_c('div', {
      staticClass: "ushk-rili_list-time"
    }, [_c('i', {
      staticClass: "ushk-icon ushk-icon_time"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.time_show))])]), _vm._v(" "), _c('star', {
      attrs: {
        "width": data.star
      }
    })], 1), _vm._v(" "), _c('h3', {
      staticClass: "ushk-rili_list-title"
    }, [_vm._v(_vm._s(data.title))]), _vm._v(" "), _c('div', {
      staticClass: "ushk-rili_list-info"
    }, [_c('p', [_vm._v("前值：\n              "), (data.revised !== null && data.revised !== '') ? [_vm._v("\n                " + _vm._s(data.revised) + "\n              ")] : [_vm._v("\n                " + _vm._s(data.previous) + _vm._s(data.unit === '%' ? data.unit : '') + "\n              ")]], 2), _vm._v(" "), _c('p', [_vm._v("预期：\n\n                "), (data.consensus !== null && data.consensus !== '') ? [_vm._v("\n                  " + _vm._s(data.consensus) + _vm._s(data.unit === '%' ? data.unit : '') + "\n                ")] : [_vm._v("\n                  ---\n                ")]], 2), _vm._v(" "), _c('p', [_vm._v("公布：\n                "), _c('span', {
      attrs: {
        "id": "<%= item.dataId %>"
      }
    }, [(data.actual !== null && data.actual !== '') ? [_vm._v("\n                    " + _vm._s(data.actual) + _vm._s(data.unit === '%' ? data.unit : '') + "\n                  ")] : [_vm._v("\n                    ---\n                  ")]], 2)])])]), _vm._v(" "), (data.show_affect && data.country !== '中国') ? _c('div', {
      staticClass: "ushk-rili_list-tag",
      attrs: {
        "id": "J_<%= item.dataId %>"
      }
    }, [_c('div', {
      staticClass: "ushk-tag_trend"
    }, [_c('p', {
      class: data.status_class ? data.status_class : 'default'
    }, [_c('span', {
      staticClass: "ushk-btn J_kind_tag",
      attrs: {
        "data-trend": "1"
      }
    }, [(data.status_name === '未公布') ? _c('em', {
      staticClass: "J_kind_trend"
    }, [_vm._v("---")]) : [_c('em', {
      staticClass: "J_kind_trend"
    }, [_vm._v(_vm._s(data.status_name))]), _vm._v(" "), _c('i', {
      staticClass: "J_kind_trendType"
    }, [_vm._v("股票")])]], 2)])])]) : _vm._e()])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67433914","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/calendar/modules/MobileContent/EconomicsList.vue
// module id = fF67
// module chunks = 3